import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: Reports from audio → Body-cam footage. Started from the
 * lesson page; never auto-started. The officer adds a video of their own, then
 * the tour points at the two footage toggles. "Analyze the footage" exists only
 * for officers with a footage seat; the step is skipped when the toggle is not
 * rendered. It stops short of the Upload button.
 */
const tour: TutorialDefinition = {
  id: "body-cam-footage",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Body-cam footage",
  description: "Upload a video, decide whether to keep it, and analyze the footage.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "body-cam-footage",
  autoStart: false,
  steps: [
    {
      target: sel("newCaseDropdown"),
      title: "Start a new case",
      content: "Click New Case, then choose Upload Files.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("newCaseUpload"), event: "click" },
      hint: "Click New Case, then Upload Files to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadDropzone"),
      waitFor: sel("uploadDropzone"),
      title: "Add the video",
      content: "Drag in an MP4 of your body-cam footage, or click to browse. Use a video file here, not just audio.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: `${sel("uploadDropzone")} input[type="file"]`, event: "change" },
      hint: "Choose a video file to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadKeepVideo"),
      waitFor: sel("uploadKeepVideo"),
      waitTimeoutMs: 10000,
      title: "Keep original video file",
      content:
        "The audio is transcribed and the video is discarded by default. Turn this on to play the video from the case later. It is available for files of 2 GB or less.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("uploadVideoAnalysis"),
      waitFor: sel("uploadVideoAnalysis"),
      waitTimeoutMs: 3000,
      title: "Analyze the footage",
      content:
        "If your admin assigned you a footage seat, this toggle lets the AI watch the video. Choose to check the draft against the footage or write footage observations into it. If you do not see it, your account has no footage seat.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("uploadSubmit"),
      waitFor: sel("uploadSubmit"),
      title: "Upload",
      content: "When the row is set, click Upload. You can close this window now to leave without uploading.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
